import { createStyles } from '@material-ui/core/styles';
import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    label: {
      marginBottom: '185px',
      position: 'relative',
      left: '-90px'
    }
  }),
);